<form [formGroup]="persoonFg">
    <div class="row">
        <snelstart-ui-text-form-control (change)="saveForm()"
                                        class="me-1 custom-input-125"
                                        formControlName="voorletters"
                                        id="voorletters"
                                        label="Voorletter(s)"
        >
        </snelstart-ui-text-form-control>
        <snelstart-ui-text-form-control (change)="saveForm()"
                                        class="me-1 custom-input-125"
                                        formControlName="tussenvoegsels"
                                        id="tussenvoegsels"
                                        label="Tussenvoegsel(s)"
        >
        </snelstart-ui-text-form-control>
    </div>

    <snelstart-ui-text-form-control (change)="saveForm()"
                                    [required]=true
                                    class="me-1 custom-input-250"
                                    formControlName="achternaam"
                                    id="achternaam"
                                    label="Achternaam"
    >
    </snelstart-ui-text-form-control>

    <snelstart-ui-email-form-control (change)="saveForm()"
                                     [required]=true
                                     class="me-1 custom-input-250"
                                     formControlName="emailadres"
                                     id="emailadres"
                                     label="E-mailadres"
    >
    </snelstart-ui-email-form-control>

    <snelstart-ui-text-form-control (change)="saveForm()"
                                    [required]=true
                                    class="me-1 custom-input-250"
                                    formControlName="telefoonnummer"
                                    id="telefoonnummer"
                                    label="Telefoonnummer"
    >
    </snelstart-ui-text-form-control>

    <snelstart-ui-text-form-control (change)="saveForm()"
                                    class="me-1 custom-input-250"
                                    formControlName="instellingnaam"
                                    id="instellingnaam"
                                    label="Naam kantoor"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-text-form-control (change)="saveForm()"
                                    class="me-1 custom-input-250"
                                    formControlName="beconnummer"
                                    id="beconnummer"
                                    label="Beconnummer kantoor"
    >
    </snelstart-ui-text-form-control>


    @if (!giftTaxEntity.aangifte?.contactPersoon?.beconnummer)
         {
           <snelstart-ui-bsn-form-control (change)="saveForm()"
                                          class="me-1 custom-input-250"
                                          formControlName="bsn"
                                          id="bsn"
                                          label="Burgerservicenummer contactpersoon"
         >
         </snelstart-ui-bsn-form-control>
          }


</form>
